import { useEffect } from "react";
import { User, useAuth0 } from "@auth0/auth0-react";
import { config } from "config";
import { USERID_CLAIMS } from "system-constants";
import {
  initOpenReplay,
  setOpenReplayMetadata,
} from "shared/openreplay/openReplayClient";

function readUserId(user: User | undefined): string | undefined {
  const claim = user?.[USERID_CLAIMS];

  return typeof claim === "string" && claim !== "" ? claim : undefined;
}

export function useOpenReplayIdentity(): void {
  const { user } = useAuth0();
  const userId = readUserId(user);
  const email = user?.email ?? "";

  useEffect(() => {
    if (userId === undefined) {
      return;
    }

    initOpenReplay(config, userId);
    setOpenReplayMetadata({ email });
  }, [userId, email]);
}
